<div class="email-id-list">
  @for (row of rows; track row; let i = $index; let last = $last) {
    <div class="email-id-list__row" [formGroup]="row">
      <div class="email-id-list__field">
        <seds-form-field-text
          [label]="i === 0 ? 'E-mail corporativo (obrigatório)' : 'E-mail corporativo'"
        >
          <input
            matInput
            type="email"
            formControlName="email"
            [attr.aria-describedby]="'email-error-' + i"
            [attr.aria-invalid]="showEmailError(row)"
            (input)="lowercaseEmail($event, row)"
          />
        </seds-form-field-text>
        @if (showEmailError(row)) {
          <span
            class="email-id-list__error"
            [id]="'email-error-' + i"
            role="alert"
          >
            <span class="material-icons-round" aria-hidden="true">warning</span>
            Digite um e-mail válido
          </span>
        }
      </div>

      <div class="email-id-list__field">
        <seds-form-field-text label="Identificação da conta">
          <input
            matInput
            formControlName="accountName"
            maxLength="21"
            [attr.aria-describedby]="'account-name-warning-' + i"
            (keypress)="validateSpecialChars($event)"
            (paste)="sanitizePaste($event, row)"
          />
        </seds-form-field-text>
        @if (showNameWarning(row)) {
          <span
            class="email-id-list__warning"
            [id]="'account-name-warning-' + i"
            role="alert"
          >
            <span class="material-icons-round" aria-hidden="true">warning</span>
            Use até 20 caracteres
          </span>
        }
      </div>
      @if (canAddRow) {
      <div class="email-id-list__add-slot">
        @if (last) {
          <button
            type="button"
            class="email-id-list__add"
            (click)="addRow()"
            aria-label="Adicionar e-mail"
          >
            <span class="material-icons" aria-hidden="true">add</span>
          </button>
        }
      </div>
    }
    </div>
  }

  <div class="email-id-list__counter" aria-live="polite">
    Restam {{ remaining }} de {{ maxEntries }} e-mails
  </div>
</div>
